import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericResultModel } from 'src/app/sharedFeatures/models/generic-result.model';
import { BaseHttpServiceService } from 'src/app/sharedFeatures/services/base-http-service.service';
import { CurrentUserService } from 'src/app/sharedFeatures/services/current-user.service';
import { MileStoneLightViewModel } from '../models/mileStone-light-view-model.model';
import { MileStoneSearchModel } from '../models/mileStone-search-model.model';
import { MileStoneViewModel } from '../models/mileStone-view-model.model';
import { MileStoneViewViewModel } from '../models/mileStone-view-view-model.model';
import { ITaskDetails } from '../models/task-details';
import { FileData } from 'src/app/sharedFeatures/models/attchment-request';
import {
  TaskFlagViewModel,
  UpdateCommonFields,
} from '../models/task-update-common-fields-request';
import { TaskCommentAdd } from '../models/task-comment-request';
import {
  MileStoneFlagViewModel,
  MileStoneLookupViewModel,
} from '../models/mileStone-lookup-view-model.model';

@Injectable({
  providedIn: 'root',
})
export class MileStoneService extends BaseHttpServiceService {
  private controller: string = `${this.baseUrl}/MileStone`;

  constructor(
    http: HttpClient,
    translateService: TranslateService,
    currentUserService: CurrentUserService
  ) {
    super(http, translateService, currentUserService);
  }
  search(
    model: MileStoneSearchModel
  ): Observable<GenericResultModel<MileStoneLightViewModel[]>> {
    let url: string = `${this.controller}/search`;
    return this.postData<GenericResultModel<MileStoneLightViewModel[]>>(
      url,
      model
    );
  }

  getLookup(): Observable<MileStoneLookupViewModel[]> {
    let url: string = `${this.controller}/searchListLookup`;
    return this.postData<MileStoneLookupViewModel[]>(url, null);
  }

  getAll(model: MileStoneSearchModel): Observable<MileStoneLightViewModel[]> {
    let url: string = `${this.controller}/getAll`;
    return this.postData<MileStoneLightViewModel[]>(url, model);
  }

  getById(id: any): Observable<MileStoneViewModel> {
    let url: string = `${this.controller}/get/${id}`;
    return this.getData<MileStoneViewModel>(url);
  }

  getViewById(id: any): Observable<MileStoneViewViewModel> {
    let url: string = `${this.controller}/details/${id}`;
    return this.getData<MileStoneViewViewModel>(url);
  }

  add(model: MileStoneViewModel): Observable<MileStoneViewModel> {
    let url: string = `${this.controller}/add`;
    return this.postData<MileStoneViewModel>(url, model);
  }
  addTask(model: MileStoneViewModel): Observable<MileStoneViewModel> {
    let url: string = `${this.controller}/add`;
    return this.postData<MileStoneViewModel>(url, model);
  }

  update(model: MileStoneViewModel): Observable<MileStoneViewModel> {
    let url: string = `${this.controller}/update`;
    return this.postData<MileStoneViewModel>(url, model);
  }
  updateFlag(
    model: MileStoneFlagViewModel
  ): Observable<MileStoneFlagViewModel> {
    let url: string = `${this.controller}/updateFlag`;
    return this.postData<MileStoneFlagViewModel>(url, model);
  }

  delete(id: any): Observable<any> {
    let url: string = `${this.controller}/delete/${id}`;
    return this.postData<any>(url, null);
  }
  deleteTask(id: any): Observable<any> {
    let url: string = `${this.baseUrl}/ProjectTask/delete/${id}`;
    return this.postData<any>(url, null);
  }

  getAllUser(): Observable<any[]> {
    let url: string = `${this.mysteryShopperUrl}/User/GetAllUsers`;
    return this.getData<any[]>(url);
  }

  getTaskById(id: number): Observable<ITaskDetails> {
    let url: string = `${this.baseUrl}/ProjectTask/details/${id}`;
    return this.getData<ITaskDetails>(url);
  }

  addAttachment(id: any, fileData: FileData): Observable<any> {
    let url: string = `${this.baseUrl}/ProjectTask/add-attachment/${id}`;
    return this.postData<any>(url, fileData);
  }
  updateCommonFields(request: UpdateCommonFields): Observable<any> {
    let url: string = `${this.baseUrl}/ProjectTask/update-common-fields`;
    return this.postData<any>(url, request);
  }
  updateTaskFlag(request: TaskFlagViewModel): Observable<any> {
    let url: string = `${this.baseUrl}/ProjectTask/updateFlag`;
    return this.postData<any>(url, request);
  }
  addComment(request: TaskCommentAdd): Observable<any> {
    let url: string = `${this.baseUrl}/TaskComment/add`;
    return this.postData<any>(url, request);
  }

  deleteGeneralAttachment(attachmentId: number): Observable<any> {
    const url = `${this.controller}/delete-attachment/${attachmentId}`; // Use the correct endpoint
    return this.postData<any>(url, null); // Use postData with null body
  }

  downloadPdf(model: MileStoneSearchModel): any {
    let url: string = `${this.controller}/export-pdf`;
    return this.exportData(url, model);
  }
  downloadExcell(model: MileStoneSearchModel): any {
    let url: string = `${this.controller}/export-excell`;
    return this.exportData(url, model);
  }

  changeIsCritical(data: any) {
    const url = `${this.controller}/updateFlag`;
    return this.postData<any>(url, data);
  }
}
